import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Analytics } from '@app/core/services/analytics/analytics.service';
@Component({
  selector: 'app-qr-error-dialog',
  templateUrl: './qr-error-dialog.component.html',
  styleUrl: './qr-error-dialog.component.scss',
})
export class QrErrorDialogComponent implements OnInit, OnDestroy {
  @Input() message: string | null = null;
  @Output() onclose = new EventEmitter<any>();

  private readonly DIALOG = 'QR Error Dialog';
  constructor(private readonly analytics: Analytics) {}

  ngOnInit(): void {
    this.analytics.dialogOpen(this.DIALOG);
  }

  onClose() {
    this.onclose.emit();
  }

  ngOnDestroy(): void {
    this.analytics.dialogClosed();
  }
}
